import type { StateCreator } from 'zustand'

import type { IRole } from '~/core/@types/global'

export interface UserRoleSlice {
  currentRole?: IRole
  setCurrentRole: (user: IRole) => void
}

export const createUserRoleSlice: StateCreator<UserRoleSlice, [], [], UserRoleSlice> = (
  set: Function
) => ({
  currentRole: undefined,
  setCurrentRole: (currentRole: IRole) => set({ currentRole })
})
